<div class="box-promo-tag-bg"></div>
<div class="box-promo-tag-content">
  <figure *ngIf="image; else showText">
    <img [src]="image" [alt]="text" />
  </figure>
  <ng-template #showText>
    <span class="ods-typography-microcopy-bold">{{ text }}</span>
  </ng-template>
</div>
